import {CREATE_GROUP_CYCLE_START} from "../../types";

export const create_group_cycle = (payload) => ({
    type: CREATE_GROUP_CYCLE_START,
    payload,
});
